<template>
  <div class="search" @touchmove.prevent @mousewheel.prevent>
    <!-- 输入框 -->
    <div class="searchBox">
      <div class="content">
        <!-- <div class="ruleTitle"><span class="f16">搜索</span></div> -->
        <div class="input">
          <van-search
            clearable
            @clear="clear()"
            :left-icon="searchIcon"
            v-model="value"
            placeholder="请输入选手编号或名称"
          />
        </div>
        <div class="searchBtn">
          <van-button class="btn" @click="gotoVote()" type="primary"
            >搜索</van-button
          >
        </div>
      </div>
    </div>
    <!-- 关闭按钮 -->
    <div class="close">
      <van-icon @click="close()" name="close" />
    </div>
  </div>
</template>

<script>
import searchMixin from "@/mixins/search.js";
export default {
  mixins: [searchMixin],
  data() {
    return {
      info: JSON.parse(sessionStorage.getItem("info")),
      searchIcon: require("@/assets/calligraphy/vote/SearchIcon.png"),
    };
  },
};
</script>

<style lang="less" scoped>
/deep/ input::placeholder {
  color: rgba(36, 48, 58, 0.5);
}
/deep/ .van-field__left-icon {
  display: grid;
  align-items: center;
  margin-right: .195rem !important;
}
/deep/ .van-field__control {
  color: rgba(36, 48, 58, 1) !important;
}
.search {
  width: 10rem;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  max-width: 10rem;
  margin: auto;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.5);
  .searchBox {
    width: 9.2rem;
    height: 4.6666667rem;
    box-sizing: border-box;
    position: relative;
    .content {
      width: 90.5%;
      // background: url('@/assets/celebrate/search/background.png');
      background: #fff;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      bottom: .2666667rem;
      left: 0;
      right: 0;
      margin: auto;
      border-radius: 0.08rem;
      height: 3.9rem;
      .ruleTitle {
        display: flex;
        justify-content: center;
        position: relative;
        color: #fff;
        padding: .84rem 0 0;
        span {
          position: relative;
          background: url("@/assets/calligraphy/btn.png") no-repeat;
          background-size: 100% 100%;
          padding: .22rem 1.1rem;
        }
        .icon1 {
          transform: rotateY(180deg);
          padding: 0 .13333rem;
        }
        .icon2 {
          padding: 0 .13333rem;
        }
      }
      .input {
        padding: .727rem 2% 0rem;
        color: #444;
        box-sizing: border-box;
        background: #fff;
        background-size: 100% 100%;
        width: 92%;
        margin: auto;
        .van-search {
          // background-color: #fff;
          padding: 0;
          border-radius: 0.08rem;
          border: 1px solid rgba(247, 164, 13, 1);
          border-radius: .5rem;
          .van-search__content {
            background: bottom;
          }
        }
        .van-search__action {
          width: 2.6666667rem;
          text-align: center;
          color: #fff;
          padding: 0;
          .searchBtn {
            color: #fff;
            position: relative;
            box-sizing: border-box;
            background: url("@/assets/finefood/voteBtn_Back.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }

      .searchBtn {
        height: .96rem;
        width: 100%;
        box-sizing: border-box;
        margin-top: .5rem;
        display: grid;
        justify-content: center;
        .btn {
          width: 3.31rem !important;
          height: 1.062rem !important;
          background: url("@/assets/finefood/voteBtn_Back.png") no-repeat !important;
          background-size: 100% 100%  !important;
          background-position: center !important;
        }
        .van-button {
          width: 100%;
          height: 100%;
          border: none;
        }
      }
    }
  }

  div.close {
    margin-top: .5333333rem;
    .van-icon-close {
      font-size: .96rem;
      color: #fff;
    }
  }
}
</style>